/**
 * external dependencies
 */
var forge = require('node-forge');


/**
 * Handles encrypting data
 * 
 * @param data the data to encrypt
 * @param publicKey the public key to use for encryption
 * @returns the encrypted data
 */
export const encryptData = (data: string) => {
  const publicKeyString = `${process.env.PUBLIC_KEY?.replace(/\\n/g, '\n')}`;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyString);
  const encrypted = publicKey.encrypt(data, "RSA-OAEP", { 
    md: forge.md.sha1.create(),
    mgf1: {
      md: forge.md.sha1.create(),
    }
  });

  const encryptedData = forge.util.encode64(encrypted);
 
  return encryptedData;
};

export const encryptDataTwo = (data: string) => {
  const publicKeyString = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAof+vW9kPxBN+KOvDbwyz
aaA6TVSDAU0nAbfYmHS6g7LnMgLHHiP+vZq41M7l2BrvKygkAnsO+AGHyqvLVR8u
57MFABViR9+XK8uhxjM31Zu3FxCPBl/r2YAm8235GEug+eGYQg9OYI/0LwOibhHv
tX3OGKTBcJEfgAt2WpjO8sybN8fYzMOHUC7xn+k/trk3Bx3qCoG22eeu3sdEu9wO
SSAD/WYAkE8UKddNuKXmrGXo5HLi7LswATTvnk0vXzi4Y1ECGvI2UpTU2GiPuKmn
ugvCWQ8VDjNg+/rMqn2WGvgiX6CXLTZvOcFkUPQdQeoqWtcF4lstq+sJedauts5H
GwIDAQAB
-----END PUBLIC KEY-----`;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyString);
  const encrypted = publicKey.encrypt(data, "RSA-OAEP", { 
    md: forge.md.sha1.create(),
    mgf1: {
      md: forge.md.sha1.create(),
    }
  });

  const encryptedData = forge.util.encode64(encrypted);
 
  return encryptedData;
};